import React from "react";
import { resolveAccentColor } from "./accentColors";

const VARIANT_PATHS = {
  marker: [
    { d: "M4 10C28 7.5 53 11.5 78 9.2C94 7.8 107 8.7 116 7.4", width: 7, opacity: 0.82 },
  ],
  "double-marker": [
    { d: "M4 7.2C29 5.2 54 8.7 82 6.7C97 5.7 108 6.2 116 5.4", width: 5, opacity: 0.72 },
    { d: "M7 12.4C31 10.2 57 13.8 83 11.4C99 10.1 109 10.9 114 10.1", width: 4, opacity: 0.5 },
  ],
  wavy: [
    { d: "M3 9C10 2.5 17 15.5 24 9S38 2.5 45 9S59 15.5 66 9S80 2.5 87 9S101 15.5 108 9S115 5 118 7", width: 3.2, opacity: 0.9 },
  ],
  brush: [
    { d: "M4 11C25 9 47 9.8 70 8.4C89 7.3 104 6.4 116 7", width: 3, opacity: 0.7 },
    { d: "M13 10.5C35 8.4 58 10.6 85 8.4C96 7.5 105 7 111 7.3", width: 8, opacity: 0.58 },
    { d: "M108 7.4C112 7.1 115 6.4 118 5.5", width: 2.5, opacity: 0.72 },
  ],
  swoosh: [
    { d: "M3 11.5C31 9.2 57 12.1 82 9.7C100 8 110 6.5 117 2.5", width: 4.5, opacity: 0.86 },
  ],
  scribble: [
    { d: "M3 10.5C17 6.8 31 13.6 45 9.4C59 5.6 74 12.8 88 8.8C100 5.6 110 11.4 118 6.6", width: 4.2, opacity: 0.92 },
    { d: "M5 14C20 10.8 33 16 49 11.8C64 8.6 78 15 93 10.8C104 8.2 112 12.8 116 10.4", width: 2.8, opacity: 0.55 },
    { d: "M9 8.5C11 8 13 7.4 15 6.6", width: 2.2, opacity: 0.6 },
  ],
};

export default function HandDrawnUnderline({
  variant = "marker",
  color = "yellow",
  className = "",
  ...props
}) {
  const paths = VARIANT_PATHS[variant] || VARIANT_PATHS.marker;
  const stroke = resolveAccentColor(color);

  return (
    <svg
      viewBox="0 0 120 18"
      preserveAspectRatio="none"
      className={`pointer-events-none ${className}`}
      aria-hidden="true"
      focusable="false"
      fill="none"
      {...props}
    >
      {paths.map((path, index) => (
        <path
          key={`${variant}-${index}`}
          d={path.d}
          stroke={stroke}
          strokeWidth={path.width}
          strokeOpacity={path.opacity}
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      ))}
    </svg>
  );
}
